import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

const DashboardLoadingState: React.FC = () => {
  return (
    <div className="h-full w-full bg-gray-50 overflow-hidden flex flex-col">
      <div className="flex-grow overflow-auto p-4 md:p-6 m-3 bg-background text-foreground border border-gray-100 rounded-xl">
        {/* Header Skeleton */}
        <div className="flex justify-between items-center mb-6">
          <div className="space-y-2">
            <div className="h-8 w-48 bg-gray-200 rounded animate-pulse" />
            <div className="h-4 w-96 bg-gray-200 rounded animate-pulse" />
          </div>
        </div>

        <div className="space-y-6">
          {/* Top Statistics Cards - Overview Skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="bg-white border border-gray-200 rounded-lg p-4 space-y-3"
              >
                <div className="h-4 w-32 bg-gray-200 rounded animate-pulse" />
                <div className="h-8 w-24 bg-gray-200 rounded animate-pulse" />
              </div>
            ))}
          </div>

          {/* Key Metrics Cards Skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="bg-white border border-gray-200 rounded-lg p-4 space-y-3"
              >
                <div className="h-4 w-32 bg-gray-200 rounded animate-pulse" />
                <div className="h-8 w-24 bg-gray-200 rounded animate-pulse" />
              </div>
            ))}
          </div>

          {/* Revenue & Metrics Overview Skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {[1, 2, 3].map((i) => (
              <Card key={i}>
                <CardHeader>
                  <div className="h-5 w-32 bg-gray-200 rounded animate-pulse" />
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    {[1, 2, 3, 4].map((j) => (
                      <div
                        key={j}
                        className="flex justify-between items-center p-3 bg-gray-50 rounded-lg"
                      >
                        <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
                        <div className="h-4 w-20 bg-gray-200 rounded animate-pulse" />
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Monthly Trends Chart Skeleton */}
          <Card>
            <CardHeader>
              <div className="h-5 w-48 bg-gray-200 rounded animate-pulse" />
            </CardHeader>
            <CardContent>
              <div className="w-full h-80 bg-gray-100 rounded animate-pulse" />
            </CardContent>
          </Card>

          {/* Revenue Trend Chart Skeleton */}
          <Card>
            <CardHeader>
              <div className="h-5 w-32 bg-gray-200 rounded animate-pulse" />
            </CardHeader>
            <CardContent>
              <div className="w-full h-80 bg-gray-100 rounded animate-pulse" />
            </CardContent>
          </Card>

          {/* Data Tables Skeleton */}
          {[1, 2, 3].map((i) => (
            <Card key={i}>
              <CardHeader>
                <div className="h-5 w-32 bg-gray-200 rounded animate-pulse" />
              </CardHeader>
              <CardContent>
                <div className="border border-gray-200 rounded-lg overflow-hidden">
                  {/* Table Header Skeleton */}
                  <div className="bg-gray-50 border-b border-gray-200">
                    <div className="flex gap-4 p-4">
                      {[1, 2, 3, 4, 5].map((j) => (
                        <div
                          key={j}
                          className="flex-1 h-4 bg-gray-200 rounded animate-pulse"
                        />
                      ))}
                    </div>
                  </div>

                  {/* Table Rows Skeleton */}
                  <div className="divide-y divide-gray-200">
                    {[1, 2, 3, 4, 5].map((j) => (
                      <div key={j} className="flex gap-4 p-4">
                        {[1, 2, 3, 4, 5].map((k) => (
                          <div
                            key={k}
                            className="flex-1 h-4 bg-gray-100 rounded animate-pulse"
                          />
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardLoadingState;
